import { getIdDisplayValue } from '@utils/index';
import { useLocationMapQuery, useLocationQuery, useNameMapQuery } from '@features/redux/apis/org';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Locations as LocationsIcon } from '@assets/index';
import { useStyles } from './styles/ViewSystemLocation.styles';
import { FormDisabledText } from '@components/forms/text/base/FormDisabledText';

type ViewSystemLocationProps = {
    locationId: number | null | undefined;
};

export const ViewSystemLocation = ({ locationId }: ViewSystemLocationProps) => {
    const classes = useStyles();
    const { data: nameMap } = useNameMapQuery({});
    const { data: locationMap } = useLocationMapQuery({});
    const { data: location, isLoading } = useLocationQuery({ locationId: locationId! }, { skip: !locationId });

    const { companyId, resellerId } = Object.fromEntries(locationMap?.locations || [])?.[locationId!] ?? {};

    return (
        <>
            {isLoading ? (
                <Box className={classes.box} height='200px'>
                    <CircularProgress size='75px' />
                </Box>
            ) : !locationId ? (
                <Box className={classes.box}>
                    <LocationsIcon />
                    <Typography fontWeight='bold'>This RapidCut system is not yet assigned to any location.</Typography>
                </Box>
            ) : (
                <>
                    <FormDisabledText
                        value={getIdDisplayValue(location?.LocationID)}
                        label={'Location ID'}
                        size={9}
                    />
                    <FormDisabledText value={location?.LocationName || 'N/A'} label={'Location Name'} size={9} />
                    <FormDisabledText
                        value={nameMap?.companies[companyId] || 'N/A'}
                        label={'Company Name'}
                        size={9}
                    />
                    <FormDisabledText
                        value={resellerId ? nameMap?.resellers[resellerId] || 'N/A' : 'N/A'}
                        label={'Reseller Name'}
                        size={9}
                    />
                    <FormDisabledText value={location?.Country || 'N/A'} label={'Country'} size={9} />
                </>
            )}
        </>
    );
};
